import * as Yup from "yup";

const BidCreateSchema = Yup.object({
    bid_quantity : Yup.number().required('Bid QTY is required!').nullable().typeError('Bid Quantity must be a valid number!').moreThan(0, 'Bid Quantity must be greater than zero!')
});

export const directPurchaseSchema = Yup.object({
    quantity : Yup.number().required('Quantity is required!').nullable().typeError('Quantity must be a valid number!')
})

export default BidCreateSchema